<template>
  <v-row class="pa-0 ma-0">
    <v-col cols="3" class="py-0">
      <v-card flat color="transparent" :style="sideContentsHeight">
        <v-card-text class="pa-0">
          <v-text-field
            v-model="search"
            append-icon="search"
            label="検索"
            clearable
            color="primary"
            class="px-2"
            @click:clear="onClear()"
            @keyup.enter.native="onSearch()">
          </v-text-field>
          <v-list color="transparent" class="py-0 px-2">
            <template v-for="(item, index) in ($route.path == '/drive' ? menuDriveItems : menuShareItems)">
              <template v-if="item.type == 'header'">
                <v-list-item class="b-B-GREY-DARK" :key="index + 'title'">
                  <span class="subtitle-1">{{ item.title }}</span>
                </v-list-item>
              </template>
              <template v-if="item.type == 'source'">
                <v-list-item
                  :key="item.title"
                  @click.stop="onList(item)"
                  >
                    <v-list-item-title>
                      <v-row class="ma-0" align="center">
                        <v-icon :class="item.iconClass" :color="selected == item.id ? item.color : 'grey lighten-1'">{{ item.icon }}</v-icon>
                        <span :class="selected == item.id ? 'primary--text' : ''">{{ item.title }}</span>
                      </v-row>
                    </v-list-item-title>
                  <v-spacer></v-spacer>
                </v-list-item>
              </template>
              <template v-if="item.type == 'share'">
                <v-list-item
                  :key="item.key + item.icon"
                  @click="onList(item)">
                  <v-list-item-title>
                    <v-row class="ma-0" align="center">
                      <v-icon :class="item.iconClass" :color="selected == item.id ? getCategoryColor(item.key): 'grey lighten-1'">{{ item.icon }}</v-icon>
                      <span :class="selected == item.id ? item.color + '--text' : ''">{{ item.title }}</span>
                    </v-row>
                  </v-list-item-title>
                </v-list-item>
              </template>
              <template v-if="item.divide">
                <v-divider :key="index" color="grey"></v-divider>
              </template>
            </template>
          </v-list>
        </v-card-text>
      </v-card>
    </v-col>

    <v-col cols="9" class="py-0">
      <v-card flat color="transparent" :style="contentsHeight">
        <v-card-text class="pa-0">
          <v-row class="ma-0 py-0" align="center">
            <v-col cols="12" class="pa-0">
              <template v-if="selected == 1">
                <template v-if="isAuthed">
                  <v-row class="ma-0 pa-0" align="center" style="height:66px;">
                    <v-col cols="6" class="py-0"></v-col>
                    <v-col cols="2" class="py-0 hidden-sm-and-down" align="end">
                      <v-btn dark rounded depressed small color="primary" v-if="isAuthed" @click="onUpdate()">
                        <!-- <v-icon>mdi-reload</v-icon> -->
                        <span class="px-0 text-none">再読込</span>
                      </v-btn>
                    </v-col>
                    <v-col cols="4" class="pa-0" align="center">
                      <v-btn dark rounded depressed small color="primary" v-if="isAuthed" @click="onDisconnectDialog()">
                        <v-icon>mdi-google-drive</v-icon>
                        <span class="px-1 text-none overflow-text-hidden">{{ gis_email }}</span>
                      </v-btn>
                    </v-col>
                  </v-row>
                </template>
                <template v-else>
                  <v-row class="ma-0 pa-0" align="center" style="height:66px;">
                    <v-col cols="12" align="end" class="pa-0">
                      <v-btn dark rounded depressed small color="grey" v-if="!isAuthed" @click="onSignIn()">
                        <v-icon>mdi-google-drive</v-icon>
                        <span class="px-1 text-none">Google Drive™ Sing-In</span>
                      </v-btn>
                    </v-col>
                  </v-row>
                </template>
              </template>
              <template v-else>
                <v-row class="ma-0 pa-0" align="center" style="height:66px"></v-row>
              </template>

              <template v-if="!searchResult || selected > 3">
                <v-row class="ma-0 pa-0" align="center">
                  <v-col cols="12" class="py-0">
                    <v-row class="ma-0 pa-0" align="center">
                      <template v-if="move">
                        <v-btn icon small @click="move = null" class="ma-0 pa-0"><v-icon color="primary">mdi-close-circle-outline</v-icon></v-btn>
                        <v-chip class="my-0 px-2" outlined small color="primary">
                          <template v-if="move.type != 'youtube'">
                            <v-avatar
                              v-if="move.mimeType == 'application/vnd.google-apps.folder'"
                              tile
                              size="18">
                              <img style="width: 18px; height: 18px;" lazy :src="move.iconLink"/>
                            </v-avatar>
                            <v-avatar
                              v-else
                              tile
                              size="16">
                              <img style="width: 16px; height: 16px;" lazy :src="getLink(move)"/>
                            </v-avatar>
                          </template>
                          <template v-else>
                            <v-avatar
                              v-if="checkFolder(move)"
                              tile
                              size="18">
                              <v-icon color="error">mdi-folder</v-icon>
                            </v-avatar>
                            <v-avatar
                              v-else
                              tile
                              size="18">
                              <v-icon color="error">mdi-youtube</v-icon>
                            </v-avatar>
                          </template>
                          {{ move.name }}
                        </v-chip>
                        <v-icon color="primary">mdi-play</v-icon>
                      </template>
                      <v-col class="pa-0" align="center">
                        <v-row class="ma-0 pa-0" align="center">
                          <v-btn v-if="(breadcrumbs.length != 0 && selected > 3)" icon small class="ma-0" @click="onCloseFolder()"><v-icon color="primary">mdi-close-circle-outline</v-icon></v-btn>
                          <v-breadcrumbs :items="breadcrumbs" class="pa-0 pl-1">
                            <template v-slot:divider>
                              <v-icon>chevron_right</v-icon>
                            </template>
                            <template slot="item" slot-scope="props">
                              <v-breadcrumbs-item>
                                <v-icon v-if="props.item.item.type != 'youtube'" size="24" class="pr-1">{{ props.item.id == 'root' ? 'mdi-folder-google-drive' : 'mdi-folder' }}</v-icon>
                                <v-icon v-else size="24" class="pr-1" color="error">mdi-folder</v-icon>
                                <a flat @click.stop="onBreadcrumbs(props.item)">{{ props.item.text }}</a>
                              </v-breadcrumbs-item>
                            </template>
                          </v-breadcrumbs>
                          <template v-if="checkPermission() && !move">
                            <v-btn rounded small @click.stop="onAddDoc($event)" class="ma-0 ml-2 py-0"><v-icon class="pr-1" color="primary">mdi-file-document-box-plus</v-icon>機能</v-btn>
                          </template>
                          <template v-else-if="checkWritePermission() && move">
                            <v-btn rounded small @click.stop="onAddDoc($event)" class="ma-0 ml-2 py-0"><v-icon class="pr-1" color="primary">mdi-file-document-box-plus</v-icon>機能</v-btn>
                          </template>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </template>
              <template v-else>
                <v-row class="ma-0 pa-0" align="center">
                  <v-col cols="12" class="py-0">
                    <v-row class="ma-0 pa-0" align="center">
                      <v-btn icon small class="ma-0" @click="onClear()"><v-icon color="primary">mdi-close-circle-outline</v-icon></v-btn>
                      <v-icon size="24" class="pl-3 pr-2">mdi-folder-search</v-icon>
                      <span>検索結果</span>
                    </v-row>
                  </v-col>
                </v-row>
              </template>
            </v-col>
          </v-row>

          <template v-if="selected == 1 && isAuthed || selected == 2">
            <v-row :hidden="loading" class="ma-0 py-0" align="center">
              <v-col cols="12" class="py-0" align="center">
                <v-row class="b-B" align="center" style="height:44px;">
                  <v-col cols="1" class="pa-0" align="start"></v-col>
                  <v-col v-for="(header, index) in heads[selected - 1]" :cols="header.width"  align="start" class="pa-0" :class="'customHeader'" :key="header.key">
                    <v-sheet class="pa-0" color="transparent">
                      <span @click="onSort(heads[selected - 1], index)" class="pa-0" @mouseenter="onMouse(heads[selected - 1], index, true)" @mouseleave="onMouse(heads[selected - 1], index, false)">{{ header.title }}</span>
                      <v-icon :color="heads[selected - 1][index].over ? 'grey' : 'transparent'">{{ getSortIcon(heads[selected - 1], index) }}</v-icon>
                    </v-sheet>
                  </v-col>
                  <v-col cols="3" class="pa-0" align="center"></v-col>
                </v-row>
              </v-col>

              <v-col cols="12" class="pa-0" align="center">
                <div class='overflow-y-auto' :style="contentsHeight" @click.right="onMenuClear($event)" @click.stop="onMenuClear($event)">
                  <RecycleScroller
                    class="scroller"
                    :items="selected == 1 ? filterItems : filterVideos"
                    :item-size="44"
                    :key-field="selected == 1 ? 'id' : 'key'"
                  >
                    <template v-slot="{ item, index }">
                      <v-row :class="item.location == 'local' ? 'ma-0 pa-0 customLine non-rcorners' : 'ma-0 pa-0 customLine rcorners'" align="center" @dblclick="selected == 1 ? onSelect(item) : onSelectShare(item)" @click.stop="onSelectItem(item, index)" @click.right.stop="onMenu($event, item, index)" style="height: 40px;">
                        <v-col cols="1" class="pa-0" align="center">
                          <template v-if="selected == 1">
                            <v-avatar
                              v-if="item.mimeType == 'application/vnd.google-apps.folder'"
                              tile
                              size="18">
                              <v-img lazy :src="item.iconLink"></v-img>
                            </v-avatar>
                            <v-avatar
                              v-else
                              tile
                              size="18">
                              <v-img lazy :src="getLink(item, item.mimeType)"></v-img>
                            </v-avatar>
                          </template>
                          <template v-else-if="selected == 2">
                            <v-avatar
                              v-if="checkFolder(item)"
                              tile
                              size="18">
                              <v-icon color="error">mdi-folder</v-icon>
                            </v-avatar>
                            <v-avatar
                              v-else
                              tile
                              size="18">
                              <v-icon color="error">mdi-youtube</v-icon>
                            </v-avatar>
                          </template>
                        </v-col>
                        <v-col v-for="(header) in heads[selected - 1]" :cols="header.width" class="pa-0" align="start" :key="header.key">
                          <template v-if="selected == 1">
                            <template v-if="header.key == 'comment'">
                              <v-tooltip bottom color="transparent">
                                <template v-slot:activator="{ on }">
                                <p v-on="on" class="select-none overflow-text-hidden ma-0">{{ item[header.key] }}</p>
                                </template>
                                <v-card width="200" class="pa-0">
                                  <v-card-text class="pa-1 caption">
                                    <span>{{ item[header.key] }}</span>
                                  </v-card-text>
                                </v-card>
                              </v-tooltip>
                            </template>
                            <template v-else>
                              <span class="select-none overflow-text-hidden">{{ item[header.key] }}</span>
                            </template>
                          </template>
                          <template v-else-if="selected == 2">
                            <template v-if="header.key == 'categoryName'">
                              <v-chip depressed small :color="getCategoryColor(item.category)" text-color="white" class="select-none">
                              <span>{{ item[header.key] }}</span>
                              </v-chip>
                            </template>
                            <template v-else-if="header.key == 'comment'">
                              <v-tooltip bottom color="transparent">
                                <template v-slot:activator="{ on }">
                                <p v-on="on" class="select-none overflow-text-hidden ma-0">{{ item[header.key] }}</p>
                                </template>
                                <v-card width="200" class="pa-0">
                                  <v-card-text class="pa-1 caption">
                                    <span>{{ item[header.key] }}</span>
                                  </v-card-text>
                                </v-card>
                              </v-tooltip>
                            </template>
                            <template v-else-if="header.key == 'visible' && item.location == 'public'">
                              <v-btn icon @click="onChangeVisible(item)"><v-icon :color="item.enable ? 'error' : 'gray'" size="medium">{{ item.enable ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline' }} </v-icon></v-btn>
                            </template>
                            <template v-else>
                              <span class="select-none overflow-text-hidden">{{ item[header.key] }}</span>
                            </template>
                          </template>
                        </v-col>
                        <v-col v-if="selected == 1" class="pa-0" align="start">
                          <v-chip v-if="item.shared" x-small :color="item.rw == 'W' ? 'success' : 'primary'" class="select-none mr-1" depressed>{{ item.rw == 'W' ? '編集可' : '閲覧可' }}</v-chip>
                          <v-chip v-if="checkShared(item) != null" x-small :color="checkShared(item) == 'public' ? 'error' : 'primary'" text-color="white" class="select-none mr-1" depressed>{{ getScope(item) }}</v-chip>
                          <template v-if="checkShared(item) != null">
                            <v-chip :color="item.categoryColor" dark x-small class="select-none" depressed>{{ item.category }}</v-chip>
                          </template>
                        </v-col>
                      </v-row>
                    </template>
                  </RecycleScroller>
                </div>
              </v-col>
            </v-row>
          </template>

          <template v-else-if="selected > 3">
            <template v-if="breadcrumbs.length == 0 || breadcrumbs.length != 0 && breadcrumbs[breadcrumbs.length - 1].item.type == 'youtube'">
              <v-row class="ma-0 py-0" align="center">
                <v-col cols="12" class="py-0" align="center">
                  <v-row class="b-B" align="center" style="height:44px;">
                    <v-col v-for="(header, index) in headers3" :cols="header.width" :align="header.key == 'read' ? 'center' : 'start'" class="pa-0" :class="'customHeader'" :key="header.key">
                      <v-sheet class="pa-0" color="transparent">
                        <template v-if="header.valid">
                          <span @click="onSort(headers3, index)" class="pa-0" @mouseenter="onMouse(headers3, index, true)" @mouseleave="onMouse(headers3, index, false)">{{ header.title }}</span>
                          <v-icon :color="headers3[index].over ? 'grey' : 'transparent'">{{ getSortIcon(headers3, index) }}</v-icon>
                        </template>
                        <template v-else>
                          <span>{{ header.title }}</span>
                          <v-icon color="transparent">mdi-folder</v-icon>
                        </template>
                      </v-sheet>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" class="py-0" align="center">
                  <div class='overflow-y-auto' :style="contentsHeight" @click.right="onMenuClear($event)" @click.stop="onMenuClear($event)">
                    <RecycleScroller
                      class="scroller"
                      :items="filterSharedItems"
                      :item-size="44"
                      key-field="key"
                    >
                      <template v-slot="{ item, index }">
                        <v-row :class="item.location == 'local' ? 'ma-0 pa-0 customLine non-rcorners' : 'ma-0 pa-0 customLine rcorners'" align="center" @dblclick="onSelectShare(item)" @click.stop="onSelectItem(item, index)" @click.right.stop="onMenu($event, item, index)" style="height: 40px;">
                          <v-col v-for="(header) in headers3" :cols="header.width" class="py-0 ma-0" align="start" :key="header.key">
                            <template v-if="header.key == 'name'">
                              <v-row class="ma-0">
                                <v-col cols="1" class="pl-0 py-0 ma-0">
                                  <template v-if="item.type == 'drive'">
                                    <v-avatar
                                      v-if="item.contents.mimeType == 'application/vnd.google-apps.folder'"
                                      tile
                                      size="20">
                                      <v-img :src="item.contents.iconLink"></v-img>
                                    </v-avatar>
                                    <v-avatar
                                      v-else
                                      tile
                                      size="18">
                                      <v-img :src="getContentsLink(item)"></v-img>
                                    </v-avatar>
                                  </template>
                                  <template v-else>
                                    <v-avatar
                                      v-if="checkFolder(item)"
                                      tile
                                      size="18">
                                      <v-icon color="error">mdi-folder</v-icon>
                                    </v-avatar>
                                    <v-avatar
                                      v-else
                                      tile
                                      size="18">
                                      <v-icon color="error">mdi-youtube</v-icon>
                                    </v-avatar>
                                  </template>
                                </v-col>
                                <v-col cols="11" class="py-0 ma-0">
                                  <span class="select-none overflow-text-hidden">{{ item[header.key] }}</span>
                                </v-col>
                              </v-row>
                            </template>
                            <template v-else-if="header.key == 'comment'">
                              <v-tooltip bottom color="transparent">
                                <template v-slot:activator="{ on }">
                                <p v-on="on" class="select-none overflow-text-hidden ma-0">{{ item[header.key] }}</p>
                                </template>
                                <v-card width="200" class="pa-0">
                                  <v-card-text class="pa-1 caption">
                                    <span>{{ item[header.key] }}</span>
                                  </v-card-text>
                                </v-card>
                              </v-tooltip>
                            </template>
                            <template v-else-if="header.key == 'read'">
                              <template v-if="$route.path == '/drive'">
                                <span v-if="!checkFolderForPlayIcon(item)" class="primary--text px-1" size="16" @click="onViewUsers(item, '')">{{ getViewNum(item, '') }}</span>
                              </template>
                              <template v-else>
                                <v-icon v-if="!checkFolderForPlayIcon(item) && checkPlayIcon(item, '')" :class="$route.path === '/share' ? 'green--text px-1' : 'gray--text px-1'" size="16"  @click="onUnread(item, '')">mdi-checkbox-marked</v-icon>
                              </template>
                            </template>
                            <span v-else class="select-none overflow-text-hidden">{{ item[header.key] }}</span>
                          </v-col>
                        </v-row>
                      </template>
                    </RecycleScroller>
                  </div>
                </v-col>
              </v-row>
            </template>
            <template v-else>
              <v-row class="ma-0 py-0" align="center">
                <v-col cols="12" class="py-0" align="center">
                  <v-row class="b-B" align="center" style="height:44px;">
                    <v-col v-for="(header, index) in headers4" :cols="header.width" :align="header.key == 'read' ? 'center' : 'start'" class="pa-0" :class="'customHeader'" :key="header.key">
                      <v-sheet class="pa-0" color="transparent">
                        <span @click="onSort(headers4, index)" class="pa-0" @mouseenter="onMouse(headers4, index, true)" @mouseleave="onMouse(headers4, index, false)">{{ header.title }}</span>
                        <v-icon :color="headers4[index].over ? 'grey' : 'transparent'">{{ getSortIcon(headers4, index) }}</v-icon>
                      </v-sheet>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" class="py-0" align="center">
                  <div class='overflow-y-auto' :style="contentsHeight" @click.right="onMenuClear($event)" @click.stop="onMenuClear($event)">
                    <RecycleScroller
                      class="scroller"
                      :items="filterSharedItems"
                      :item-size="44"
                      key-field="id"
                    >
                      <template v-slot="{ item, index }">
                        <v-row class="ma-0 pa-0 customLine" align="center" @dblclick="onSelect(item)" @click.stop="onSelectItem(item, index)" @click.right.stop="onMenu($event, item, index)" style="height: 44px;">
                          <v-col v-for="(header) in headers4" :cols="header.width" class="pa-0" align="start" :key="header.key">
                            <template v-if="header.key == 'name'">
                              <v-row>
                                <v-col cols="1" class="px-0">
                                  <v-avatar
                                    v-if="item.mimeType == 'application/vnd.google-apps.folder'"
                                    tile
                                    size="20">
                                    <v-img lazy :src="item.iconLink"></v-img>
                                  </v-avatar>
                                  <v-avatar
                                    v-else
                                    tile
                                    size="18">
                                    <v-img lazy :src="getLinkForDrive(item)"></v-img>
                                  </v-avatar>
                                </v-col>
                                <v-col cols="11" class="pl-0">
                                  <span class="select-none overflow-text-hidden">{{ item[header.key] }}</span>
                                </v-col>
                              </v-row>
                            </template>
                            <template v-else-if="header.key == 'read'">
                              <template v-if="$route.path == '/drive'">
                                <span v-if="!checkFolderForDrivePlayIcon(item)" class="primary--text px-1" size="16"  @click="onViewUsers(item, 'drive')">{{ getViewNum(item, 'drive') }}</span>
                              </template>
                              <template v-else>
                                <v-icon v-if="!checkFolderForDrivePlayIcon(item) && checkPlayIcon(item, 'drive')" :class="$route.path === '/share' ? 'green--text px-1' : 'gray--text px-1'" size="16" @click="onUnread(item, 'drive')">mdi-checkbox-marked</v-icon>
                              </template>
                            </template>
                            <span v-else class="select-none overflow-text-hidden">{{ item[header.key] }}</span>
                          </v-col>
                        </v-row>
                      </template>
                    </RecycleScroller>
                  </div>
                </v-col>
              </v-row>
            </template>
          </template>
        </v-card-text>
      </v-card>
    </v-col>

    <div>
      <app-basic-dialog
        @dismissed="onDismissed"
        :title="'Google Drive™'"
        :message="'サインアウトします。よろしいですか?'"
        :dialog='dialogSignout'
        :color="'error'"
        :cancel='true'>
      </app-basic-dialog>
    </div>

    <div>
      <v-row class="ma-0 pa-0" align="center">
        <v-col cols="12" class="pa-0">
          <v-menu
            v-model='showMenu'
            transition="slide-y-transition"
            :position-x="x"
            :position-y="y"
            absolute
            offset-y
            min-width="200"
          >
            <v-list v-if="showMenu" dense>
              <template v-if="move">
                <v-list-item
                  v-for="(item, i) in moveItems"
                  :key="i + item.id"
                  @click="onMenuSelect(item, i)"
                  :disabled="!checkShareable(item)"
                >
                  <v-row class="ma-0 pa-0" align="center" :key="i + item.id">
                    <v-chip outlined>
                      <v-col cols="1" class="pa-0">
                        <v-icon size="22" :color="checkShareable(item) ? item.iconColor : 'grey'">{{ item.icon }}</v-icon>
                      </v-col>
                      <v-col class="py-0" align="start">
                        <span>{{ item.title }}</span>
                      </v-col>
                    </v-chip>
                  </v-row>
                </v-list-item>
              </template>
              <template v-else-if="!item && breadcrumbs.length != 0">
                <v-list-item
                  v-for="(item, i) in (breadcrumbs[breadcrumbs.length - 1].item.type == 'youtube' ? createYouTubeItems : createItems)"
                  :key="i + item.id"
                  @click="onMenuSelect(item, i)"
                  :disabled="!checkShareable(item)"
                >
                  <v-row class="ma-0 pa-0" align="center" :key="i + item.id">
                    <v-chip outlined>
                      <v-col cols="1" class="pa-0" align="center">
                        <v-icon size="22" :color="checkShareable(item) ? item.iconColor : 'grey'" style="margin-bottom: 2px;">{{ item.icon }}</v-icon>
                      </v-col>
                      <v-col class="py-0" align="start">
                        <span>{{ item.title }}</span>
                      </v-col>
                    </v-chip>
                  </v-row>
                </v-list-item>
              </template>
              <template v-else-if="item">
                <template v-for="(item, i) in selected >= 4 ? sharedItems : actionItems">
                  <template v-if="checkAvailable(item)">
                    <v-list-item
                      :key="i"
                      @click="onMenuSelect(item, i)"
                      :disabled="!checkShareable(item)"
                    >
                      <v-row class="ma-0 pa-0" align="center" :key="i + item.id">
                        <v-col cols="1" class="pa-0" align="center">
                          <v-icon size="22" :color="checkShareable(item) ? item.iconColor : 'grey'" style="margin-bottom: 2px;">{{ item.icon }}</v-icon>
                        </v-col>
                        <v-col class="py-0" align="start">
                          <span>{{ item.title }}</span>
                        </v-col>
                      </v-row>
                    </v-list-item>
                  </template>
                </template>
              </template>
            </v-list>
          </v-menu>
        </v-col>
      </v-row>
    </div>

    <div>
      <v-row class="ma-0 pa-0" align="center">
        <v-col cols="12" class="pa-0">
          <v-dialog
            v-model='dialogShare'
            persistent
            max-width="400px">
            <v-card v-if="dialogShare" flat>
              <v-card-title class="title primary white--text">
                <v-icon class="white--text px-1">mdi-share-variant</v-icon>
                <span>共有</span>
              </v-card-title>
              <v-card-text class="pb-0">
                <v-row class="ma-0 pa-0" align="center">
                  <v-col cols="12" class="pa-0">
                    <v-text-field
                      v-model="tempItem.name"
                      label="名称"
                      readonly
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" class="pa-0">
                    <v-textarea
                      prepend-inner-icon="mdi-pencil-box"
                      name="input"
                      label="説明"
                      v-model="tempItem.comment"
                      outlined
                      hide-details
                    ></v-textarea>
                  </v-col>
                  <v-row class="ma-0 pa-0" align="center">
                    <v-col cols="12" class="py-0">
                      <v-select
                        ref="category"
                        v-model="tempItem.category"
                        :items="$DESCRIPTIONS_ITEMS"
                        label="分類"
                        :rules="[rules.required]"
                        item-text="name"
                        item-value="key"
                        small-chips
                      ></v-select>
                    </v-col>
                    <v-col cols="12" class="py-0">
                      <v-select
                        v-model="tempItem.scope"
                        :items="$SHARES"
                        label="公開範囲"
                        item-text="name"
                        item-value="key"
                        small-chips
                      ></v-select>
                    </v-col>
                  </v-row>
                </v-row>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn depressed rounded @click.native="dialogShare = false">取消</v-btn>
                <v-btn depressed rounded color="primary" @click="onShare()">{{ tempItem.key ? '変更' : '作成' }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-col>
      </v-row>
    </div>

    <div>
      <v-row class="ma-0 pa-0" align="center">
        <v-col cols="12" class="pa-0">
          <v-dialog
            v-model="dialogCreate"
            persistent
            max-width="400px">
            <v-card v-if="dialogCreate" flat>
              <v-card-title class="title primary white--text">
                <v-icon class="white--text px-1">{{ docInfo.icon }}</v-icon>
                <span>新規作成</span>
              </v-card-title>
              <v-card-text class="py-2 px-4">
                <v-text-field
                  ref="fileName"
                  v-model="name"
                  label="名称"
                  :rules="[rules.required]"
                ></v-text-field>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn depressed rounded @click.native="dialogCreate = false">取消</v-btn>
                <v-btn depressed rounded color="primary" @click="onCreateDocument()">作成</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-col>
      </v-row>
    </div>

    <div>
      <v-row class="ma-0 pa-0" align="center">
        <v-col cols="12" class="pa-0" align="center">
          <v-dialog
            v-model='dialogPermission'
            persistent
            max-width="400px">
            <v-card v-if="dialogPermission">
              <v-card-title class="title error white--text">
                <v-icon class="white--text px-1">mdi-account-plus</v-icon>
                <span>アクセス権変更</span>
              </v-card-title>
              <v-card-text class="py-2 px-4">
                <v-radio-group v-model="permission">
                  <v-radio
                    v-for="(item, index) in itemsPermission"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                    color="error">
                  </v-radio>
                </v-radio-group>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn depressed rounded @click.native="dialogPermission = false">取消</v-btn>
                <v-btn color="error" depressed rounded @click="onChangePermission()">変更</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-col>
      </v-row>
    </div>

    <div>
      <v-row class="ma-0 pa-0" align="center">
        <v-col cols="12" class="pa-0" align="center">
          <v-dialog
            v-model='dialogRename'
            persistent
            max-width="400px">
            <v-card v-if="dialogRename">
              <v-card-title class="title primary white--text">
                <v-icon class="white--text px-1">mdi-pencil-box</v-icon>
                <span>名称変更</span>
              </v-card-title>
              <v-card-text class="py-2 px-4">
                <v-text-field
                  ref="rename"
                  v-model="name"
                  label="名称"
                  :rules="[rules.required]"
                ></v-text-field>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn depressed rounded @click.native="dialogRename = false">取消</v-btn>
                <v-btn depressed rounded color="primary" @click="onChangeName()">変更</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-col>
      </v-row>
    </div>

    <div>
      <v-row class="ma-0 pa-0" align="center">
        <v-col cols="12" class="pa-0" align="center">
          <v-dialog
            v-model='dialogCopy'
            persistent
            max-width="400px">
            <v-card v-if="dialogCopy">
              <v-card-title class="title primary white--text">
                <v-icon class="white--text px-1">mdi-pencil-box</v-icon>
                <span>複製</span>
              </v-card-title>
              <v-card-text class="py-2 px-4">
                <v-text-field
                  ref="rename"
                  v-model="name"
                  label="名称"
                  :rules="[rules.required]"
                ></v-text-field>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn depressed rounded @click.native="dialogCopy = false">取消</v-btn>
                <v-btn depressed rounded color="primary" @click="onCopyDocument()">複製</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-col>
      </v-row>
    </div>

    <div>
      <v-row class="ma-0 pa-0" align="center">
        <v-col cols="12" class="pa-0" align="center">
          <v-dialog
            v-model='dialogDelete'
            persistent
            max-width="400px">
            <v-card v-if="dialogDelete">
              <v-card-title class="title error white--text">
                <v-icon class="white--text px-1">mdi-trash-can-outline</v-icon>
                <span>{{ '削除' + (selected == 1 ? '（Google Drive™）' : '（共有情報）') }}</span>
              </v-card-title>
              <v-card-text class="py-2 px-4">
                <span>{{ '「' + item.name + '」' }}</span>
                <span class="red--text">{{ selected == 1 ? 'を削除します。Google Drive™ 上のデータが削除されますが、本当によろしいですか?' : 'を削除します。よろしいですか?' }}</span>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn depressed rounded @click.native="dialogDelete = false">取消</v-btn>
                <v-btn depressed rounded color="error" @click="onDelete()">削除</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-col>
      </v-row>
    </div>

    <div>
      <v-row class="ma-0 pa-0" align="center">
        <v-col cols="12" class="pa-0" align="center">
          <v-dialog
            v-model='dialogYoutube'
            persistent
            max-width="640"
            max-height="360"
            class="pa-0 ma-0"
            >
              <template-youtube v-if="dialogYoutube" :item="item" @closed="onClose"></template-youtube>
          </v-dialog>
        </v-col>
      </v-row>
    </div>

    <div class="text-center">
      <v-row class="ma-0 pa-0" align="center">
        <v-col cols="12" class="pa-0" align="center">
          <v-dialog
            v-model='dialogYoutubeEdit'
            persistent
            max-width="400px">
            <v-card v-if="dialogYoutubeEdit">
              <v-card-title class="title error white--text">
                <v-icon class="white--text px-1">mdi-youtube</v-icon>
                <span>動画マニュアル</span>
              </v-card-title>
              <v-card-text class="pb-0">
                <v-row class="ma-0 pa-0" align="center">
                  <v-col cols="12" class="pa-0">
                    <v-text-field
                      ref="name"
                      v-model="item.name"
                      label="名称"
                      :rules="[rules.required]"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" class="pa-0">
                    <v-textarea
                      prepend-inner-icon="mdi-pencil-box"
                      name="input"
                      label="説明"
                      v-model="item.comment"
                      outlined
                      hide-details
                    ></v-textarea>
                  </v-col>
                  <v-row v-if="!item.key" class="ma-0" align="center">
                    <v-col cols="5" class="py-0">
                      <v-select
                        v-model="item.contents.id"
                        :items="$VIDEO_ID"
                        label="種別"
                        item-text="name"
                        item-value="key"
                        small-chips
                      ></v-select>
                    </v-col>
                    <v-col cols="7" class="pa-0">
                      <v-text-field
                        v-if="item.contents.id == 'video'"
                        ref="video"
                        v-model="item.contents.video"
                        label="YouTube ID"
                        clearable
                        :rules="[rules.required]"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row v-else class="ma-0" align="center">
                    <v-col cols="5" class="py-0">
                    </v-col>
                    <v-col cols="7" class="pa-0">
                      <v-text-field
                        v-if="item.contents.id != 'folder'"
                        ref="video"
                        v-model="item.contents.video"
                        label="YouTube ID"
                        clearable
                        :rules="[rules.required]"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-col v-if="item.contents.video" cols="12" class="pa-0" align="center">
                    <embed height="180" width="320" :src="'https://www.youtube.com/embed/' + item.contents.video"/>
                  </v-col>
                  <v-row class="ma-0" align="center">
                    <v-col cols="7" class="py-0">
                      <v-select
                        ref="category"
                        v-model="item.category"
                        :items="$DESCRIPTIONS_ITEMS"
                        label="分類"
                        :rules="[rules.required]"
                        item-text="name"
                        item-value="key"
                        small-chips
                      ></v-select>
                    </v-col>
                    <v-col cols="5" class="py-0">
                      <v-select
                        v-model="item.scope"
                        :items="$SCOPES"
                        label="公開範囲"
                        item-text="name"
                        item-value="key"
                        small-chips
                      ></v-select>
                    </v-col>
                  </v-row>
                </v-row>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn depressed rounded @click.native="dialogYoutubeEdit = false">取消</v-btn>
                <v-btn depressed rounded color="primary" @click="onShareYouTube()">{{ item.key ? '変更' : '作成' }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-col>
      </v-row>
    </div>

    <v-snackbar
      v-model="snackbar"
      color="green"
      :multi-line="mode === 'multi-line'"
      :timeout="timeout"
      :top="true"
      :vertical="mode === 'vertical'">
      {{ '共有可能なリンクをクリップボードへコピーしました' }}
      <v-btn dark rounded small color="primary" @click.stop.prevent="snackbar = false">閉じる</v-btn>
    </v-snackbar>

    <div>
      <app-basic-dialog
        @dismissed="onDismissed"
        title="マイドライブ"
        message="マイドライブへ複製するには Googleアカウントで Sign-in してください"
        :dialog='authErrorDialog'
        :color="'error'"
        :cancel='false'>
      </app-basic-dialog>
    </div>

    <div v-if="snackbar2" class="text-center">
      <v-snackbar
        color="success"
        v-model="snackbar2"
      >
        {{ 'コンテンツを未読にしました' }}

        <template v-slot:action="{ attrs }">
          <v-btn
            color="pink"
            text
            v-bind="attrs"
            @click="snackbar2 = false"
          >
            Close
          </v-btn>
        </template>
      </v-snackbar>
    </div>

  <v-row v-if="dialog" justify="center">
    <v-dialog
      v-model="dialog"
      scrollable
      max-width="300px"
    >
      <v-card>
        <v-toolbar
          color="primary"
          dark
          elevation="0"
        >
          <span class="overflow-text-hidden subtitle-1">{{ viewItemName }}</span>

          <v-spacer></v-spacer>
        </v-toolbar>
        <v-divider></v-divider>
        <v-card-text style="height: 300px;" class="pa-1">
          <v-list class="pa-0 ma-0">
            <v-list-item
              v-for="(item, index) in viewUsersList"
              :key="index"
              class="pa-0 ma-0"
            >
              <v-list-item-avatar class="mx-2 my-0">
                <v-avatar size="34">
                  <img v-if="getAvatar(item)" :src='getAvatar(item)'>
                  <v-avatar v-else size="32" :color="item.color ? item.color : 'primary'"><span class="font-weight-bold white--text" style="font-size:23px; user-select: none; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">{{ getNamePrefix(item) }}</span></v-avatar>
                </v-avatar>
              </v-list-item-avatar>
              <v-list-item-content class="pa-0 ma-0">
                <v-list-item-title class="overflow-text-hidden black--text">
                  {{ item.title }}
                </v-list-item-title>
                <v-list-item-subtitle class="overflow-text-hidden primary--text">
                  {{ item.subtitle }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            rounded depressed
            @click="dialog = false"
          >
            閉じる
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>

    <div>
      <app-loading :loading="loading"></app-loading>
    </div>

  </v-row>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import moment from 'moment-timezone'
import Clipboard from 'v-clipboard'
import YouTube from '../../components/google/YouTube.vue'
// import { googleKeys } from '../../prototype.js'
Vue.use(Clipboard)
Vue.component('template-youtube', YouTube)

var async = require('async')

export default {
  computed: {
    ...mapGetters({
      user: 'auth/user',
      data: 'auth/data',
      users: 'users/users',
      schools: 'schools/schools',
      shares: 'shares/shares',
      windowSize: 'shared/windowSize',
      sharesStatics: 'sharesStatics/shares',
      sharesPublics: 'sharesPublics/shares',
      statuses: 'statuses/statuses'
    }),
    viewUsersList () {
      var temp = []
      if (this.viewItem) {
        var index = this.sharesStatics.findIndex(share => share.key === this.viewItem)
        if (index !== -1) {
          var keys = Object.keys(this.sharesStatics[index].whoRead)
          for (var x in keys) {
            if (this.sharesStatics[index].whoRead[keys[x]]) {
              var payload = {
                avatar: null,
                title: '',
                subtitle: ''
              }
              var u = this.users.findIndex(user => user.key === keys[x])
              if (u !== -1) {
                payload.title = this.users[u].name
                if (this.users[u].avatar) {
                  payload.avatar = this.users[u].avatar.thumbnail
                }
                var s = this.schools.findIndex(school => school.key === this.users[u].primary)
                if (s !== -1) {
                  payload.subtitle = this.schools[s].name
                }
              }
              temp.push(payload)
            }
          }
        }
        temp.sort(function (a, b) {
          if (a.subtitle > b.subtitle) return 1
          if (a.subtitle < b.subtitle) return -1
          return 0
        })
      }
      return temp
    },
    filterItems () {
      var temp = []
      moment.tz.setDefault('Asia/Tokyo')
      for (var i in this.tempItems) {
        var payload = this.tempItems[i]
        payload.ownerName = this.getOwnerName(this.tempItems[i])
        payload.updatedDate = moment(this.tempItems[i].modifiedTime).format('YYYY-MM-DD')
        payload.rw = this.getRW(this.tempItems[i])
        var category = this.getCategoryByID(this.tempItems[i])
        payload.category = category.name
        payload.categoryColor = category.color
        payload.comment = this.getCommentByID(this.tempItems[i])
        temp.push(payload)
      }
      var key = null
      for (i in this.headers) {
        if (this.headers[i].value) {
          key = this.headers[i].key
          if (this.headers[i].value === 1) {
            temp.sort(function (a, b) {
              if (a[key] > b[key]) return -1
              if (a[key] < b[key]) return 1
              return 0
            })
          } else {
            temp.sort(function (a, b) {
              if (a[key] < b[key]) return -1
              if (a[key] > b[key]) return 1
              return 0
            })
          }
          break
        }
      }
      return temp
    },
    filterVideos () {
      var temp = []
      for (var i in this.shares) {
        var payload = JSON.parse(JSON.stringify(this.shares[i]))
        payload.ownerName = this.getOwnerName(this.shares[i])
        payload.updatedDate = moment(this.shares[i].updatedAt).format('YYYY-MM-DD')
        payload.categoryName = this.getCategory(payload)
        payload['location'] = 'local'

        if (payload.type !== 'youtube') {
          continue
        }
        var school = null
        var keys = Object.keys(payload.schools)
        for (var x in keys) {
          if (payload.schools[keys[x]]) {
            school = keys[x]
            break
          }
        }
        if (!this.data.schools[school]) {
          continue
        }
        if (this.search) {
          if (payload.name.indexOf(this.search) !== -1) {
            temp.push(payload)
          }
        } else {
          if (typeof payload.contents.parents === 'undefined' || payload.contents.parents === 'root') {
            if (this.breadcrumbs[this.breadcrumbs.length - 1].id !== 'root') {
              continue
            }
          } else if (payload.contents.parents !== this.breadcrumbs[this.breadcrumbs.length - 1].id) {
            continue
          }
          temp.push(payload)
        }
      }

      for (i in this.sharesPublics) {
        payload = JSON.parse(JSON.stringify(this.sharesPublics[i]))

        if (payload.type !== 'youtube') {
          continue
        }

        payload.ownerName = this.getOwnerName(this.sharesPublics[i])
        payload.updatedDate = moment(this.sharesPublics[i].updatedAt).format('YYYY-MM-DD')
        payload.categoryName = this.getCategory(payload)
        payload['location'] = 'public'

        if (payload.type !== 'youtube') {
          continue
        }
        if (this.search) {
          if (payload.name.indexOf(this.search) !== -1) {
            temp.push(payload)
          }
        } else {
          if (typeof payload.contents.parents === 'undefined' || payload.contents.parents === 'root') {
            if (this.breadcrumbs[this.breadcrumbs.length - 1].id !== 'root') {
              continue
            }
          } else if (payload.contents.parents !== this.breadcrumbs[this.breadcrumbs.length - 1].id) {
            continue
          }
          temp.push(payload)
        }
      }

      var key = null
      for (i in this.headers2) {
        if (this.headers2[i].value) {
          key = this.headers2[i].key
          if (this.headers2[i].value === 1) {
            temp.sort(function (a, b) {
              if (a[key] > b[key]) return -1
              if (a[key] < b[key]) return 1
              return 0
            })
          } else {
            temp.sort(function (a, b) {
              if (a[key] < b[key]) return -1
              if (a[key] > b[key]) return 1
              return 0
            })
          }
          break
        }
      }
      return temp
    },
    filterSharedItems () {
      var temp = []
      moment.tz.setDefault('Asia/Tokyo')
      if (this.breadcrumbs.length === 0) {
        for (var i in this.shares) {
          var payload = JSON.parse(JSON.stringify(this.shares[i]))
          payload.schoolName = this.getSchool(payload)
          payload.categoryName = this.getCategory(payload)
          payload['location'] = 'local'

          if (!this.checkPrivilege(payload)) {
            continue
          }
          if (!this.search && this.shares[i].type === 'youtube') {
            if (typeof payload.contents.parents !== 'undefined' && payload.contents.parents !== 'root') {
              continue
            }
            if (this.selected >= 4 && this.selected <= 8) {
              continue
            } else {
              temp.push(payload)
            }
          }
          if (this.selected === 4 || (this.selected !== 4 && (this.selected - 4) === payload.category)) {
            if (this.search) {
              if (payload.name.indexOf(this.search) !== -1) {
                temp.push(payload)
              }
            } else {
              temp.push(payload)
            }
          }
        }

        for (i in this.sharesPublics) {
          payload = JSON.parse(JSON.stringify(this.sharesPublics[i]))

          if (payload.type !== 'youtube' || this.selected !== 9) {
            continue
          }

          if (!this.sharesPublics[i].enable) {
            continue
          }

          payload.schoolName = this.getSchool(payload)
          payload.categoryName = this.getCategory(payload)
          payload['location'] = 'public'

          if (!this.checkPrivilege(payload)) {
            continue
          }
          if (!this.search) {
            if (typeof payload.contents.parents !== 'undefined' && payload.contents.parents !== 'root') {
              continue
            }
            temp.push(payload)
          } else if (payload.name.indexOf(this.search) !== -1) {
            temp.push(payload)
          }
        }

        var key = null
        for (i in this.headers3) {
          if (this.headers3[i].value) {
            key = this.headers3[i].key
            if (this.headers3[i].value === 1) {
              temp.sort(function (a, b) {
                if (a[key] > b[key]) return -1
                if (a[key] < b[key]) return 1
                return 0
              })
            } else {
              temp.sort(function (a, b) {
                if (a[key] < b[key]) return -1
                if (a[key] > b[key]) return 1
                return 0
              })
            }
            break
          }
        }
      } else {
        if (this.breadcrumbs[this.breadcrumbs.length - 1].item.type === 'youtube') {
          for (i in this.shares) {
            payload = JSON.parse(JSON.stringify(this.shares[i]))
            payload.schoolName = this.getSchool(payload)
            payload.categoryName = this.getCategory(payload)
            payload['location'] = 'local'

            if (payload.type !== 'youtube') {
              continue
            }
            if (!this.checkPrivilege(payload)) {
              continue
            }
            if (typeof payload.contents.parents === 'undefined' || payload.contents.parents === 'root') {
              if (this.breadcrumbs[this.breadcrumbs.length - 1].id !== 'root') {
                continue
              }
            } else if (payload.contents.parents !== this.breadcrumbs[this.breadcrumbs.length - 1].id) {
              continue
            }
            if (this.search) {
              if (payload.name.indexOf(this.search) !== -1) {
                temp.push(payload)
              }
            } else {
              temp.push(payload)
            }
          }

          for (i in this.sharesPublics) {
            payload = JSON.parse(JSON.stringify(this.sharesPublics[i]))

            if (payload.type !== 'youtube') {
              continue
            }

            payload.schoolName = this.getSchool(payload)
            payload.categoryName = this.getCategory(payload)
            payload['location'] = 'public'

            if (!this.checkPrivilege(payload)) {
              continue
            }
            if (typeof payload.contents.parents === 'undefined' || payload.contents.parents === 'root') {
              if (this.breadcrumbs[this.breadcrumbs.length - 1].id !== 'root') {
                continue
              }
            } else if (payload.contents.parents !== this.breadcrumbs[this.breadcrumbs.length - 1].id) {
              continue
            }
            if (this.search) {
              if (payload.name.indexOf(this.search) !== -1) {
                temp.push(payload)
              }
            } else {
              temp.push(payload)
            }
          }

          key = null
          for (i in this.headers3) {
            if (this.headers3[i].value) {
              key = this.headers3[i].key
              if (this.headers3[i].value === 1) {
                temp.sort(function (a, b) {
                  if (a[key] > b[key]) return -1
                  if (a[key] < b[key]) return 1
                  return 0
                })
              } else {
                temp.sort(function (a, b) {
                  if (a[key] < b[key]) return -1
                  if (a[key] > b[key]) return 1
                  return 0
                })
              }
              break
            }
          }
        } else {
          for (i in this.tempItems) {
            payload = this.tempItems[i]
            if (this.search) {
              if (payload.name.indexOf(this.search) !== -1) {
                payload.ownerName = this.getOwnerName(this.tempItems[i])
                payload.updatedDate = moment(this.tempItems[i].modifiedTime).format('YYYY-MM-DD')
                payload.rw = this.getRW(this.tempItems[i])
                payload.category = this.getDescription(this.tempItems[i])
                temp.push(payload)
              }
            } else {
              if (this.getRW(this.tempItems[i]) !== '-') {
                if (this.type === 'open') {
                  payload.schoolName = this.getSchool(this.breadcrumbs[this.breadcrumbs.length - 1].item)
                  payload.categoryName = this.getCategory(this.breadcrumbs[this.breadcrumbs.length - 1].item)
                  payload.categoryColor = this.getCategoryColor(this.breadcrumbs[this.breadcrumbs.length - 1].item.category)
                } else {
                  payload.schoolName = this.breadcrumbs[this.breadcrumbs.length - 1].item.schoolName
                  payload.categoryName = this.breadcrumbs[this.breadcrumbs.length - 1].item.categoryName
                  payload.category = this.breadcrumbs[this.breadcrumbs.length - 1].item.categor
                }
                temp.push(payload)
              }
            }
          }
          key = null
          for (i in this.headers4) {
            if (this.headers4[i].value) {
              key = this.headers4[i].key
              if (this.headers4[i].value === 1) {
                temp.sort(function (a, b) {
                  if (a[key] > b[key]) return -1
                  if (a[key] < b[key]) return 1
                  return 0
                })
              } else {
                temp.sort(function (a, b) {
                  if (a[key] < b[key]) return -1
                  if (a[key] > b[key]) return 1
                  return 0
                })
              }
              break
            }
          }
        }
      }
      return temp
    },
    sideContentsHeight () {
      return 'background: transparent; height: ' + String(this.windowSize.y - 60 - 4 - 40) + 'px;'
    },
    contentsHeight () {
      return 'background: transparent; height: ' + String(this.windowSize.y - 60 - 66 - 28 - 48 - 40) + 'px;'
    },
    form1 () {
      return {
        name: this.item.name,
        category: this.item.category
      }
    },
    heads () {
      return [ this.headers, this.headers2, this.headers3, this.headers4 ]
    }
  },
  props: [ 'type', 'openItem' ],
  data () {
    return {
      loading: false,
      dialog: false,
      authErrorDialog: false,
      dialogShare: false,
      dialogCreate: false,
      dialogPermission: false,
      dialogRename: false,
      dialogDelete: false,
      dialogCopy: false,
      dialogYoutube: false,
      dialogYoutubeEdit: false,
      dialogSignout: false,
      searchResult: false,
      snackbar: false,
      timeout: 3000,
      mode: '',
      isAuthed: false,
      nextPageToken: null,
      item: null,
      tempItem: null,
      items: [],
      tempItems: [],
      search: null,
      headers: [
        { over: false, value: 2, title: '名称', key: 'name', width: '3' },
        { over: false, value: 0, title: '説明', key: 'comment', width: '2' },
        { over: false, value: 0, title: '更新日', key: 'updatedDate', width: '2' }
      ],
      headers2: [
        { over: false, value: 2, title: '名称', key: 'name', width: '3' },
        { over: false, value: 0, title: '説明', key: 'comment', width: '3' },
        { over: false, value: 0, title: '分類', key: 'categoryName', width: '2' },
        { over: false, value: 0, title: '更新日', key: 'updatedDate', width: '2' },
        { over: false, value: 0, title: '', key: 'visible', width: '1' }
      ],
      headers3: [
        { valid: false, over: false, value: 0, title: '既読', key: 'read', width: '1' },
        { valid: true, over: false, value: 2, title: '名称', key: 'name', width: '4' },
        { valid: false, over: false, value: 0, title: '説明', key: 'comment', width: '7' }
      ],
      headers4: [
        { valid: false, over: false, value: 0, title: '既読', key: 'read', width: '1' },
        { over: false, value: 2, title: '名称', key: 'name', width: '11' }
      ],
      sortIcons: [
        'mdi-menu-swap',
        'mdi-menu-down',
        'mdi-menu-up'
      ],
      breadcrumbs: [],
      breadcrumbs2: [],
      selected: 1,
      menuShareItems: [
        { id: 0, type: 'header', title: 'マイドライブ', divide: false },
        { id: 1, type: 'source', icon: 'mdi-folder-google-drive', iconClass: 'pr-1', title: 'Google Drive™', color: 'primary', divide: false, add: false },
        { id: 3, type: 'header', title: '共有ファイル', divide: false },
        { id: 4, type: 'share', icon: 'mdi-folder', iconClass: 'pr-1', title: '全分類', key: 0, color: 'primary', divide: false },
        { id: 5, type: 'share', icon: 'mdi-folder', iconClass: 'pr-1', title: '教室運営', key: 1, color: 'primary', divide: false },
        { id: 6, type: 'share', icon: 'mdi-folder', iconClass: 'pr-1', title: '販売促進', key: 2, color: 'primary', divide: false },
        { id: 7, type: 'share', icon: 'mdi-folder', iconClass: 'pr-1', title: '人事', key: 3, color: 'primary', divide: false },
        { id: 8, type: 'share', icon: 'mdi-folder', iconClass: 'pr-1', title: '教務', key: 4, color: 'primary', divide: true },
        { id: 9, type: 'share', icon: 'mdi-youtube', iconClass: 'pr-1', title: '動画マニュアル', key: 5, color: 'error', divide: false }
      ],
      menuDriveItems: [
        { id: 0, type: 'header', title: '共有元資料', divide: false },
        { id: 1, type: 'source', icon: 'mdi-folder-google-drive', iconClass: 'pr-1', title: 'Google Drive™', color: 'primary', divide: false, add: false },
        { id: 2, type: 'source', icon: 'mdi-folder', iconClass: 'pr-1', title: '動画マニュアル', color: 'red', divide: false, add: false },
        { id: 3, type: 'header', title: '共有先プレビュー', divide: false },
        { id: 4, type: 'share', icon: 'mdi-folder', iconClass: 'pr-1', title: '全分類', key: 0, color: 'primary', divide: false },
        { id: 5, type: 'share', icon: 'mdi-folder', iconClass: 'pr-1', title: '教室運営', key: 1, color: 'primary', divide: false },
        { id: 6, type: 'share', icon: 'mdi-folder', iconClass: 'pr-1', title: '販売促進', key: 2, color: 'primary', divide: false },
        { id: 7, type: 'share', icon: 'mdi-folder', iconClass: 'pr-1', title: '人事', key: 3, color: 'primary', divide: false },
        { id: 8, type: 'share', icon: 'mdi-folder', iconClass: 'pr-1', title: '教務', key: 4, color: 'primary', divide: true },
        { id: 9, type: 'share', icon: 'mdi-youtube', iconClass: 'pr-1', title: '動画マニュアル', key: 5, color: 'error', divide: false }
      ],
      itemIndex: null,
      showMenu: false,
      x: 0,
      y: 0,
      createItems: [
        { id: 'folder', title: '新しいフォルダ', icon: 'mdi-folder-plus', color: 'grey--text pr-1', iconColor: 'primary', divide: false, mime: 'application/vnd.google-apps.folder', name: '無題のフォルダ' },
        { id: 'docs', title: 'Google ドキュメント', icon: 'mdi-file-document-box', color: 'blue--text pr-1', iconColor: 'blue', divide: false, mime: 'application/vnd.google-apps.document', name: '無題のドキュメント' },
        { id: 'sheets', title: 'Google スプレッドシート', icon: 'mdi-google-spreadsheet', color: 'green--text pr-1', iconColor: 'green', divide: false, mime: 'application/vnd.google-apps.spreadsheet', name: '無題のスプレッドシート' },
        { id: 'slides', title: 'Google スライド', icon: 'mdi-file-presentation-box', color: 'amber--text pr-1', iconColor: 'amber', divide: true, mime: 'application/vnd.google-apps.presentation', name: '無題のプレゼンテーション' }
      ],
      createYouTubeItems: [
        { id: 'vfolder', title: '新しいフォルダ', icon: 'mdi-folder', color: 'pr-1', iconColor: 'error', divide: false, mime: '', name: '' },
        { id: 'video', title: '新しい動画', icon: 'mdi-youtube', color: 'pr-1', iconColor: 'error', divide: true, mime: '', name: '' }
      ],
      moveItems: [
        { id: 'folder', title: '新しいフォルダ', icon: 'mdi-folder-plus', color: 'grey--text pr-1', iconColor: 'primary', divide: false, mime: 'application/vnd.google-apps.folder', name: '無題のフォルダ' },
        { id: 'domove', title: 'ここへ作成', icon: 'mdi-folder-move', color: 'blue--text pr-1', iconColor: 'blue', divide: false, mime: '', name: '' }
      ],
      actionItems: [
        { id: 'share', title: '共有', icon: 'mdi-share-variant', divider: false, iconColor: 'primary', shared: false, drive: true, video: true },
        { id: 'copy', title: '複製', icon: 'mdi-content-copy', divider: false, iconColor: 'primary', shared: true, drive: true, video: false },
        { id: 'move', title: '指定の場所へ移動', icon: 'mdi-folder-move', divider: false, iconColor: 'primary', shared: true, drive: true, video: true },
        { id: 'permission', title: 'アクセス権変更', icon: 'mdi-shield-account-outline', divider: false, iconColor: 'error', shared: true, drive: true, video: false },
        { id: 'link', title: '共有可能なリンクを取得', icon: 'mdi-link', divider: false, iconColor: 'primary', shared: true, drive: true, video: false },
        { id: 'rename', title: '名前の変更', icon: 'mdi-pencil-box', divider: false, iconColor: 'primary', shared: true, drive: true, video: false },
        { id: 'delete', title: '削除', icon: 'mdi-trash-can-outline', divider: false, iconColor: 'error', shared: true, drive: true, video: true }
      ],
      sharedItems: [
        { id: 'share', title: '共有', icon: 'mdi-share-variant', divider: false, iconColor: 'primary', shared: false, drive: true },
        { id: 'move', title: '指定の場所へ移動', icon: 'mdi-folder-move', divider: false, iconColor: 'primary', shared: false, drive: false },
        { id: 'save', title: 'マイドライブへ複製', icon: 'mdi-folder-move', divider: false, iconColor: 'primary', shared: true, drive: false },
        { id: 'delete', title: '削除', icon: 'mdi-trash-can-outline', divider: false, iconColor: 'error', shared: false, drive: true }
      ],
      itemsPermission: [
        { value: 3, label: '編集可 - リンクを知っている全員が編集可能' },
        { value: 2, label: '閲覧可 - リンクを知っている全員が閲覧可能' },
        { value: 1, label: 'オフ - 特定のユーザだけがアクセスできます' }
      ],
      permission: 1,
      name: null,
      docInfo: null,
      rules: {
        required: value => !!value || '必須.'
      },
      move: null,
      moveFromFolder: null,
      action: null,
      snackbar2: false,
      viewItem: null,
      viewItemName: ''
    }
  },
  watch: {
    isSignedIn () {
      this.gapiUpdateSigninStatus(this.isSignedIn)
    },
    $route (to, from) {
      if (this.$route.path === '/drive') {
        this.selected = 1
        this.onList(this.menuDriveItems[1])
      } else {
        this.onList(this.menuShareItems[3])
      }
    }
  },
  created () {
    window.gapi.load('client', this.gisInit)
  },
  mounted () {
    if (this.$route.path === '/drive') {
      this.selected = 1
      this.onList(this.menuDriveItems[1])
    } else {
      if (this.type === 'open' && this.openItem !== null && this.openItem.type === 'youtube') {
        this.onList(this.menuShareItems[8])
        this.item = this.openItem
        this.onSelectShare(this.openItem)
      } else if (this.type === 'open' && this.openItem !== null) {
        this.onList(this.menuShareItems[3 + this.openItem.category])
        this.item = this.openItem
        this.onSelectShare(this.openItem)
      } else {
        this.onList(this.menuShareItems[3])
      }
    }
  },
  methods: {
    checkPrivilege (item) {
      if (item.scope === 'public') {
        return true
      }
      if (item.scope === 'local') {
        var keys = Object.keys(this.data.schools)
        for (var i in keys) {
          if (this.data.schools[keys[i]]) {
            return item.schools[keys[i]]
          }
        }
      }
      if (item.scope === 'restrict') {
        keys = Object.keys(this.data.schools)
        for (i in keys) {
          if (this.data.schools[keys[i]]) {
            return item.schools[keys[i]] && this.data.role !== 'teacher'
          }
        }
      }
      return false
    },
    checkPermission () {
      if (this.selected > 2) {
        return false
      }
      if (this.breadcrumbs.length !== 0) {
        if (this.breadcrumbs[this.breadcrumbs.length - 1].id === 'root') {
          return 'W'
        }
        if (typeof this.breadcrumbs[this.breadcrumbs.length - 1].item.contents === 'undefined') {
          return this.getRW(this.breadcrumbs[this.breadcrumbs.length - 1].item) === 'W'
        }
        if (this.breadcrumbs[this.breadcrumbs.length - 1].item.type === 'youtube') {
          return 'W'
        }
        return this.getRW(this.breadcrumbs[this.breadcrumbs.length - 1].item.contents) === 'W'
      }
      return false
    },
    checkWritePermission () {
      if (this.breadcrumbs.length !== 0) {
        if (this.breadcrumbs[this.breadcrumbs.length - 1].id === 'root') {
          return true
        }
        if (this.breadcrumbs[this.breadcrumbs.length - 1].item.type === 'youtube') {
          return true
        }
        for (var index in this.breadcrumbs[this.breadcrumbs.length - 1].item.owners) {
          if (this.breadcrumbs[this.breadcrumbs.length - 1].item.owners[index].me) {
            return true
          }
          return this.getPermission(this.breadcrumbs[this.breadcrumbs.length - 1].item).permission === 3
        }
      }
      return false
    },
    checkAvailable (item) {
      if (this.$route.path === '/drive') {
        switch (this.selected) {
          case 1:
            return item.drive
          case 2:
            return item.video
          default:
            return item.drive
        }
      }
      if (this.$route.path === '/share') {
        if (this.item.type === 'youtube') {
          return false
        }
        switch (this.selected) {
          case 1:
            return item.shared
          default:
            return item.shared
        }
      }
    },
    checkFolderForDrivePlayIcon (item) {
      if (typeof item.mimeType === 'undefined') {
        return true
      }
      return item.mimeType === 'application/vnd.google-apps.folder'
    },
    checkFolderForPlayIcon (item) {
      if (typeof item.contents === 'undefined') {
        return true
      }
      if (item.type !== 'youtube') {
        if (typeof item.contents.mimeType === 'undefined') {
          return true
        }
        return item.contents.mimeType === 'application/vnd.google-apps.folder'
      }
      return item.contents.id === 'folder'
    },
    checkPlayIcon (item, type) {
      var id = null
      if (type === 'drive') {
        id = item.id
      } else if (item.type === 'youtube') {
        id = item.contents.video
      } else {
        id = item.contents.id
      }
      var index = this.sharesStatics.findIndex(share => share.key === id)
      if (index !== -1) {
        return this.sharesStatics[index].whoRead[this.user.uid]
      }
      return false
    },
    getViewNum (item, type) {
      var id = null
      var num = 0
      if (type === 'drive') {
        id = item.id
      } else if (item.type === 'youtube') {
        id = item.contents.video
      } else {
        id = item.contents.id
      }
      var index = this.sharesStatics.findIndex(share => share.key === id)
      if (index !== -1) {
        var keys = Object.keys(this.sharesStatics[index].whoRead)
        for (var i in keys) {
          if (this.sharesStatics[index].whoRead[keys[i]]) {
            num += 1
          }
        }
      }
      return num
    },
    getAvatar (item) {
      var url = null
      if (item.avatar) {
        url = item.avatar
      }
      return url
    },
    getNamePrefix (item) {
      var name = '？'
      if (item.title) {
        name = item.title.slice(0, 1)
      }
      return name
    },
    onChangeVisible (item) {
      this.$store.dispatch('sharesPublics/changeVisible', JSON.parse(JSON.stringify(item))).then(() => {
      })
    },
    onUnread (item, type) {
      var id = null
      if (this.$route.path === '/share') {
        if (type === 'drive') {
          id = item.id
        } else if (item.type === 'youtube') {
          id = item.contents.video
        } else {
          id = item.contents.id
        }
        this.itemLogs(id, false)
        this.snackbar2 = true
      }
    },
    onViewUsers (item, type) {
      var vm = this
      var id = null
      var name = ''
      if (type === 'drive') {
        id = item.id
        name = item.name
      } else if (item.type === 'youtube') {
        id = item.contents.video
        name = item.name
      } else {
        id = item.contents.id
        name = item.name
      }
      this.viewItem = id
      this.viewItemName = name
      vm.dialog = true
    },
    checkFolder (item) {
      if (item.type !== 'youtube') {
        return false
      }
      if (typeof item.contents.id === 'undefined') {
        return false
      }
      return item.contents.id === 'folder'
    },
    getLinkForDrive (item) {
      if (item.type) {
        return ''
      }
      if (item.mimeType.indexOf('video') !== -1 || item.mimeType.indexOf('image') !== -1) {
        return item.thumbnailLink
      }
      return item.iconLink
    },
    getCategoryColor (category) {
      if (category === 5) {
        return 'error'
      }
      var index = this.$DESCRIPTIONS_ITEMS.findIndex(description => description.key === category)
      if (index !== -1) {
        return this.$DESCRIPTIONS_ITEMS[index].color
      }
      return 'primary'
    },
    getSchool (item) {
      var keys = Object.keys(item.schools)
      for (var i in keys) {
        if (item.schools[keys[i]]) {
          const index = this.schools.findIndex(school => school.key === keys[i])
          if (index !== -1) {
            return this.schools[index].name
          }
        }
      }
      return 'N/A'
    },
    getScope (item) {
      var index = this.$SHARES.findIndex(s => s.key === this.checkShared(item))
      if (index !== -1) {
        return this.$SHARES[index].name
      }
      return ''
    },
    getSortIcon (headers, item) {
      return this.sortIcons[headers[item].value]
    },
    getCategory (item) {
      var index = this.$DESCRIPTIONS_ITEMS.findIndex(description => description.key === item.category)
      if (index !== -1) {
        return this.$DESCRIPTIONS_ITEMS[index].name
      }
      return 'N/A'
    },
    getCommentByID (item) {
      var index = this.shares.findIndex(function (share) {
        if (share.type === 'drive') {
          return item.id === share.contents.id
        }
      })
      if (index !== -1) {
        return this.shares[index].comment
      }
      return ''
    },
    getCategoryByID (item) {
      var index = this.shares.findIndex(function (share) {
        if (share.type === 'drive') {
          return item.id === share.contents.id
        }
      })
      if (index !== -1) {
        return { name: this.getCategory(this.shares[index]), color: this.getCategoryColor(this.shares[index].category) }
      }
      return { name: null, color: null }
    },
    onMouse (headers, item, value) {
      headers[item].over = value
    },
    onSort (headers, item) {
      var temp = headers[item].value += 1
      if (temp === 3) {
        temp = 0
      }
      for (var i in headers) {
        headers[i].value = 0
      }
      headers[item].value = temp
    },
    getPermission (item) {
      var permission = 1
      var id = null
      for (var index in item.permissions) {
        if (item.permissions[index].role !== 'owner') {
          id = item.permissions[index].id
          if (item.permissions[index].role === 'reader') {
            permission = 2
          } else {
            permission = 3
          }
        }
      }
      return { 'permission': permission, 'id': id }
    },
    onSelectItem (item, index) {
      this.itemIndex = index
      this.item = item
      if (this.type === 'dialog') {
        if (this.selected === 1) {
          if (item.rw !== '-' && item.mimeType !== 'application/vnd.google-apps.folder') {
            this.$emit('change', { selected: this.selected, item: item })
          } else {
            this.$emit('change', { selected: null, item: null })
          }
        } else {
          this.$emit('change', { selected: this.selected, item: item })
        }
      }
    },
    onMenu (e, item, index) {
      e.preventDefault()
      if (this.$route.path === '/chat') {
        return
      }
      if (this.$route.path === '/drive') {
        if (item.location === 'public') {
          return false
        }
      }
      if (this.$route.path === '/share') {
        if (item.type === 'youtube') {
          return
        }
      }
      if (this.$route.path === '/share') {
        if (item.type === 'drive' && this.selected !== 1 && item.contents.mimeType === 'application/vnd.google-apps.folder') {
          return
        }
      }
      if (this.$route.path === '/share') {
        if (this.selected !== 1 && item.mimeType === 'application/vnd.google-apps.folder') {
          return
        }
      }
      this.itemIndex = index
      this.item = item
      this.showMenu = false
      this.x = e.clientX
      this.y = e.clientY
      this.$nextTick(() => {
        this.showMenu = true
      })
    },
    onMenuClear (e) {
      this.showMenu = false
      this.itemIndex = null
      this.item = null
      e.preventDefault()
    },
    onAddDoc (e) {
      this.itemIndex = null
      this.item = null
      this.showMenu = false
      this.x = e.clientX
      this.y = e.clientY
      this.$nextTick(() => {
        this.showMenu = true
      })
    },
    onMenuSelect (item, i) {
      if (item.id === 'save') {
        if (!this.isAuthed) {
          this.authErrorDialog = true
        } else {
          this.move = this.item
          this.selected = 1
          this.onList(this.menuDriveItems[1])
          this.moveFromFolder = null
          this.itemIndex = null
          this.action = item
        }
      } else if (item.id === 'vfolder' || item.id === 'video') {
        this.item = JSON.parse(JSON.stringify(this.$store.getters['shares/initial']))
        this.item.scope = 'local'
        this.item.type = 'youtube'
        this.item.owner = this.user.uid
        this.item.contents = {
          id: item.id !== 'video' ? 'folder' : 'video',
          mimeType: item.id === 'video' ? 'video/x-youtube' : null,
          video: null,
          parents: this.breadcrumbs[this.breadcrumbs.length - 1].id
        }
        this.dialogYoutubeEdit = true
      } else if (item.id === 'folder' || item.id === 'docs' || item.id === 'sheets' || item.id === 'slides') {
        this.docInfo = item
        this.name = item.name
        this.dialogCreate = true
      } else if (item.id === 'share') {
        var temp = this.item
        if (this.selected > 3) {
          if (this.item.type === 'drive') {
            temp = this.item.contents
          }
        }
        this.onShareDialog(temp)
      } else if (item.id === 'link') {
        this.$clipboard(this.selected > 3 ? this.item.contents.webViewLink : this.item.webViewLink)
        this.snackbar = true
      } else if (item.id === 'permission') {
        this.permission = this.getPermission(this.item).permission
        this.dialogPermission = true
      } else if (item.id === 'rename') {
        this.name = this.item.name
        this.dialogRename = true
      } else if (item.id === 'copy') {
        this.name = this.item.name
        this.dialogCopy = true
      } else if (item.id === 'delete') {
        this.dialogDelete = true
      } else if (item.id === 'move') {
        this.move = this.item
        this.moveFromFolder = this.breadcrumbs[this.breadcrumbs.length - 1]
        this.itemIndex = null
      } else if (item.id === 'domove') {
        if (this.action && this.action.id === 'save') {
          this.onSaveDocument()
          this.action = null
        } else {
          this.onMove()
        }
        this.move = null
      }
    },
    onAdd (item) {
      this.item = JSON.parse(JSON.stringify(this.$store.getters['shares/initial']))
      if (item) {
        var index = this.shares.findIndex(share => share.key === item.key)
        if (index !== -1) {
          this.item = JSON.parse(JSON.stringify(this.shares[index]))
        }
      } else {
        this.item.scope = 'local'
        this.item.type = 'youtube'
        this.item.owner = this.user.uid
        var temp = {
          id: 'video',
          mimeType: 'video/x-youtube',
          video: this.item.contents.video ? this.item.contents.video : null
        }
        this.item.contents = temp
      }
      this.dialogYoutubeEdit = true
    },
    onShareDialog (item) {
      if (item.type === 'youtube') {
        this.tempItem = item
        this.dialogYoutubeEdit = true
        return
      }
      this.dialogShare = true
      this.tempItem = JSON.parse(JSON.stringify(this.$store.getters['shares/initial']))
      var index = this.shares.findIndex(share => share.contents.id === item.id)
      if (index !== -1) {
        this.tempItem = JSON.parse(JSON.stringify(this.shares[index]))
      } else {
        this.tempItem.scope = 'local'
        this.tempItem.type = 'drive'
        this.tempItem.owner = this.user.uid
      }
      this.tempItem.name = item.name
      this.tempItem.contents = JSON.parse(JSON.stringify(item))
      this.dialogShare = true
    },
    onShare () {
      var vm = this
      this.formHasErrors = false
      if (!this.$refs.category.validate(true)) {
        return
      }
      const index = this.users.findIndex(user => user.key === this.user.uid)
      if (index === -1) {
        return
      }
      var school = null
      var keys = Object.keys(this.users[index].schools)
      for (var i in keys) {
        if (this.users[index].schools[keys[i]]) {
          school = keys[i]
          break
        }
      }
      this.loading = true
      this.tempItem.schools[school] = true
      if (!this.tempItem.key) {
        this.tempItem.createdAt = parseInt(new Date().getTime())
      }
      this.tempItem.updatedAt = parseInt(new Date().getTime())
      var sharesKeys = Object.keys(JSON.parse(JSON.stringify(this.$store.getters['shares/initial'])))
      var payload = JSON.parse(JSON.stringify(this.$store.getters['shares/initial']))
      for (var x in sharesKeys) {
        payload[sharesKeys[x]] = this.tempItem[sharesKeys[x]]
      }
      this.$store.dispatch('shares/write', JSON.parse(JSON.stringify(payload))).then(() => {
        vm.loading = false
        vm.dialogShare = false
      })
    },
    onShareDelete () {
      var vm = this
      this.loading = true
      var payload = this.tempItem.key
      this.$store.dispatch('shares/delete', JSON.parse(JSON.stringify(payload))).then(() => {
        vm.loading = false
        vm.dialogShare = false
      })
    },
    onShareYouTube (item) {
      var vm = this
      this.formHasErrors = false
      Object.keys(this.form1).forEach(f => {
        if (!this.form1[f]) {
          this.formHasErrors = true
        }
        this.$refs[f].validate(true)
      })
      if (this.formHasErrors) {
        return
      }
      if (!this.item.key) {
        const index = this.users.findIndex(user => user.key === this.user.uid)
        if (index === -1) {
          return
        }
        var school = null
        var keys = Object.keys(this.users[index].schools)
        for (var i in keys) {
          if (this.users[index].schools[keys[i]]) {
            school = keys[i]
            break
          }
        }
        this.item.schools[school] = true
        this.item.createdAt = parseInt(new Date().getTime())
      }
      this.loading = true
      this.item.updatedAt = parseInt(new Date().getTime())

      var sharesKeys = Object.keys(JSON.parse(JSON.stringify(this.$store.getters['shares/initial'])))
      var payload = JSON.parse(JSON.stringify(this.$store.getters['shares/initial']))
      for (var x in sharesKeys) {
        payload[sharesKeys[x]] = this.item[sharesKeys[x]]
      }

      this.$store.dispatch('shares/write', JSON.parse(JSON.stringify(payload))).then(() => {
        vm.loading = false
        vm.dialogYoutubeEdit = false
      })
    },
    onClear () {
      this.search = null
    },
    onCloseFolder () {
      this.showMenu = false
      this.item = null
      this.items = []
      this.tempItems = []
      this.breadcrumbs = []
      this.search = null
      this.searchResult = false
      this.nextPageToken = null
    },
    onUpdate () {
      var vm = this
      vm.loading = true
      if (this.selected === 1 && this.breadcrumbs.length !== 0) {
        this.$nextTick(function () {
          vm.tempItems = []
          vm.items = []
          vm.breadcrumbs = []
          vm.search = null
          vm.searchResult = false
          vm.nextPageToken = null
          vm.gapiListFiles(true).then(function () {
            vm.loading = false
          })
        })
      } else {
        this.$nextTick(function () {
          vm.gapiListSubFiles(this.breadcrumbs[this.breadcrumbs.length - 1].item, false).then(function () {
            vm.loading = false
          })
        })
      }
    },
    onBreadcrumbs (item) {
      var temp = []
      for (var i = 0; i < this.breadcrumbs.length; i++) {
        if (this.breadcrumbs[i].id === item.id) {
          temp.push(this.breadcrumbs[i])
          break
        } else {
          temp.push(this.breadcrumbs[i])
        }
      }
      this.tempItems = item.items
      this.breadcrumbs = temp
      this.itemIndex = null
      if (this.breadcrumbs[this.breadcrumbs.length - 1].update) {
        this.breadcrumbs[this.breadcrumbs.length - 1].update = false
        this.onUpdate()
      }
    },
    onCreateDocument () {
      this.dialogCreate = false
      if (this.$refs.fileName.validate(true)) {
        var vm = this
        this.loading = true
        var payload = {
          'resource': {
            'name': this.name,
            'mimeType': this.docInfo.mime,
            'parents': [ this.item ? this.item.id : this.breadcrumbs[this.breadcrumbs.length - 1].id ]
          },
          'fields': '*'
        }
        window.gapi.client.drive.files.create(payload).then(function (res) {
          vm.loading = false
          vm.onUpdate()
          if (res.result.mimeType !== 'application/vnd.google-apps.folder') {
            window.open(res.result.webViewLink, '_blank')
          }
        }, function (error) {
          if (error) {
          }
        })
      }
    },
    onChangePermission () {
      var vm = this
      this.dialogPermission = false
      var temp = this.getPermission(this.item)
      if (temp.permission !== this.permission) {
        this.loading = true
        var payload = { 'fileId': this.item.id }
        if (this.permission === 1) {
          payload['permissionId'] = temp.id
          window.gapi.client.drive.permissions.delete(payload).then(function (res) {
            vm.loading = false
            vm.onUpdate()
          })
        } else if (this.permission === 2) {
          payload['resource'] = {
            'role': 'reader',
            'type': 'anyone'
          }
          window.gapi.client.drive.permissions.create(payload).then(function (res) {
            vm.loading = false
            vm.onUpdate()
          })
        } else if (this.permission === 3) {
          payload['resource'] = {
            'role': 'writer',
            'type': 'anyone'
          }
          window.gapi.client.drive.permissions.create(payload).then(function (res) {
            vm.loading = false
            vm.onUpdate()
          })
        }
      }
    },
    onChangeName () {
      if (this.$refs.rename.validate(true)) {
        var vm = this
        this.loading = true
        var payload = {
          'resource': { 'name': this.name },
          'fields': '*',
          'fileId': this.item.id
        }
        window.gapi.client.drive.files.update(payload).then(function (res) {
          vm.loading = false
          vm.onUpdate()
        })
        this.dialogRename = false
      }
    },
    onCopyDocument () {
      if (this.$refs.rename.validate(true)) {
        var vm = this
        this.loading = true
        this.dialogCopy = false
        var body = { 'name': this.name }
        var request = window.gapi.client.drive.files.copy({
          'fileId': this.item.id,
          'resource': body
        })
        request.execute(function (resp) {
          vm.loading = false
          vm.onUpdate()
        })
      }
    },
    onSaveDocument () {
      var vm = this
      this.loading = true
      this.dialogCopy = false
      var id = this.move.id
      if (this.move.type && this.move.type === 'drive') {
        id = this.move.contents.id
      }
      var body = { 'name': this.name, 'parents': [ this.breadcrumbs[this.breadcrumbs.length - 1].id ] }
      var request = window.gapi.client.drive.files.copy({
        'fileId': id,
        'resource': body
      })
      request.execute(function (resp) {
        vm.loading = false
        vm.onUpdate()
      })
    },
    onDelete () {
      var vm = this
      this.loading = true
      var payload = null
      if (this.selected >= 2) {
        payload = this.item.key
        this.$store.dispatch('shares/delete', JSON.parse(JSON.stringify(payload))).then(() => {
          vm.loading = false
        })
      } else {
        payload = {
          'fileId': this.item.id,
          'fields': 'parents'
        }
        if (this.checkOwner(this.item)) {
          window.gapi.client.drive.files.get(payload).then(function (res) {
            payload['removeParents'] = res.result.parents.join(',')
            window.gapi.client.drive.files.update(payload).then(function (res) {
              vm.loading = false
              vm.onUpdate()
            })
          })
        } else {
          window.gapi.client.drive.files.delete(payload).then(function (res) {
            vm.loading = false
            vm.onUpdate()
          })
        }
      }
      this.dialogDelete = false
    },
    onMove () {
      var vm = this
      if (typeof this.move.type !== 'undefined' && this.move.type === 'youtube') {
        if (this.move.key !== this.breadcrumbs[this.breadcrumbs.length - 1].id) {
          this.move.contents['parents'] = this.breadcrumbs[this.breadcrumbs.length - 1].id
          this.loading = true
          this.move.updatedAt = parseInt(new Date().getTime())

          var sharesKeys = Object.keys(JSON.parse(JSON.stringify(this.$store.getters['shares/initial'])))
          var payload = JSON.parse(JSON.stringify(this.$store.getters['shares/initial']))
          for (var x in sharesKeys) {
            payload[sharesKeys[x]] = this.move[sharesKeys[x]]
          }
          this.$store.dispatch('shares/write', JSON.parse(JSON.stringify(payload))).then(() => {
            vm.loading = false
          })
        }
      } else {
        payload = {
          'fields': 'id, parents',
          'fileId': this.move.id,
          'addParents': this.breadcrumbs[this.breadcrumbs.length - 1].id,
          'removeParents': this.move.parents.join(',')
        }
        this.loading = true
        window.gapi.client.drive.files.update(payload).then(function (res) {
          vm.loading = false
          vm.moveFromFolder.update = true
          vm.onUpdate()
        })
      }
    },
    onDisconnectDialog () {
      this.dialogSignout = true
    },
    onDisconnect () {
      this.gisSignOut()
      this.dialogSignout = false
    },
    onDismissed: function (value) {
      if (this.authErrorDialog) {
        this.authErrorDialog = false
        return
      }
      if (this.dialogSignout) {
        this.dialogSignout = false
        if (value) {
          this.onDisconnect()
        }
        return
      }
      if (value.update) {
        this.items = []
        if (this.breadcrumbs.length === 1) {
          this.gapiListFiles(false)
        } else {
          this.gapiListSubFiles(this.breadcrumbs[this.breadcrumbs.length - 1].item, false)
        }
        this.item = null
      }
      this.dialog = false
    },
    onLoading: function (value) {
      this.loading = value.loading
    },
    onList (item) {
      var vm = this
      this.item = null
      this.searchResult = false
      this.tempItems = this.items = []
      this.selected = item.id
      this.itemIndex = null
      this.breadcrumbs = []
      this.search = null
      if (this.selected === 1) {
        if (this.isAuthed) {
          this.loading = true
          this.gapiListFiles(true).then(function () {
            vm.loading = false
          })
        }
      } else if (this.selected === 2) {
        vm.breadcrumbs.push({
          text: '動画マニュアル',
          disabled: false,
          update: false,
          id: 'root',
          items: null,
          item: { type: 'youtube' }
        })
      }
      if (this.type === 'dialog') {
        this.$emit('change', { selected: null, item: null })
      }
      this.item = null
    },
    onSelect (item) {
      var vm = this
      if (item.type === 'youtube') {
        this.onAdd(item)
        return
      }
      if (item.mimeType === 'application/vnd.google-apps.folder') {
        vm.loading = true
        this.$nextTick(function () {
          vm.gapiListSubFiles(item, true).then(function () {
            vm.itemIndex = null
            vm.loading = false
          })
        })
      } else {
        window.open(item.webViewLink, '_blank')
        this.itemLogs(item.id, true)
      }
    },
    itemLogs (key, status) {
      if (this.$route.path === '/share') {
        var payload = {
          key: key,
          status: status,
          uid: this.user.uid
        }
        this.$store.dispatch('sharesStatics/update', payload)
      }
    },
    onSelectShare (item) {
      var vm = this
      if (item.type === 'youtube') {
        this.item = JSON.parse(JSON.stringify(item))
        if (item.contents.id && item.contents.id === 'folder') {
          vm.breadcrumbs.push({
            text: this.item.name,
            disabled: false,
            update: false,
            id: this.item.key,
            items: null,
            item: this.item
          })
        } else {
          this.dialogYoutube = true
          this.itemLogs(item.contents.video, true)
        }
        vm.itemIndex = null
      } else if (this.breadcrumbs.length !== 0) {
        if (item.mimeType === 'application/vnd.google-apps.folder') {
          vm.loading = true
          this.$nextTick(function () {
            vm.gapiListSubFiles(item, true).then(function () {
              vm.itemIndex = null
              vm.loading = false
            })
          })
        } else {
          window.open(item.webViewLink, '_blank')
          this.itemLogs(item.id, true)
        }
      } else if (item.type === 'drive') {
        if (item.contents.mimeType === 'application/vnd.google-apps.folder') {
          if (this.type === 'dialog') {
            return
          }
          vm.loading = true
          this.$nextTick(function () {
            vm.gapiListSubFiles(item, true).then(function () {
              vm.itemIndex = null
              vm.loading = false
            })
          })
        } else {
          window.open(item.contents.webViewLink, '_blank')
          this.itemLogs(item.contents.id, true)
        }
      }
    },
    onClose () {
      if (this.dialogYoutube) {
        this.dialogYoutube = false
      } else if (this.type === 'dialog') {
        this.$emit('dismissed', null)
      }
    },
    onSearch () {
      var vm = this
      if (this.search !== null && this.search !== '') {
        this.searchResult = true
        this.loading = true
        this.items = []
        this.gapiListFiles(true).then(function () {
          vm.loading = false
        })
      } else {
        this.onUpdate()
      }
    },
    getDescription (item) {
      if (typeof item.description === 'undefined') {
        return null
      }
      var index = this.$DESCRIPTIONS_ITEMS.findIndex(description => description.key === parseInt(item.description))
      if (index !== -1) {
        return this.$DESCRIPTIONS_ITEMS[index].name
      }
      return null
    },
    getThumbLink (item) {
      if (item.mimeType.indexOf('vnd.google-apps.') !== -1) {
        return item.thumbnailLink + '&access_token=' + this.access_token
      }
      return item.thumbnailLink
    },
    checkShared (item) {
      var index = this.shares.findIndex(function (share) {
        return share.type === 'drive' && share.contents.id === item.id
      })
      if (index !== -1) {
        return this.shares[index].scope
      }
      return null
    },
    checkShareable (item) {
      if (item.id === 'copy') {
        return !(this.item.mimeType === 'application/vnd.google-apps.folder')
      }
      if (item.id !== 'share') {
        return true
      }
      if (!this.item) {
        return false
      }
      if (this.selected === 2) {
        return true
      }
      if (this.selected > 3) {
        return true
      }
      return this.item.shared
    },
    checkShare () {
      if (!this.item) {
        return false
      }
      if (!this.item.shared) {
        return false
      }
      var share = false
      for (var index in this.item.owners) {
        share = this.item.owners[index].me
      }
      return share
    },
    checkOwner (item) {
      if (item.type === 'youtube') {
        return item.owner === this.user.uid
      } else if (item !== null) {
        for (var index in item.owners) {
          return !item.owners[index].me
        }
      }
      return false
    },
    getLink (item, x) {
      if (item.type === 'youtube') {
        return ''
      }
      if (typeof item.mimeType === 'undefined') {
        return ''
      }
      if (item.mimeType.indexOf('video') !== -1 || item.mimeType.indexOf('image') !== -1) {
        return item.thumbnailLink
      }
      return item.iconLink
    },
    getContentsLink (item) {
      if (item.contents.mimeType.indexOf('video') !== -1 || item.contents.mimeType.indexOf('image') !== -1) {
        return item.contents.iconLink
      }
      return item.contents.iconLink
    },
    getRW (item) {
      var permission = '-'
      if (item.shared) {
        for (var index in item.permissions) {
          if (item.permissions[index].role === 'reader') {
            return 'R'
          }
          if (item.permissions[index].role === 'writer') {
            return 'W'
          }
        }
        permission = 'R'
      }
      return permission
    },
    getSize (item) {
      var size = Math.floor(parseInt(item.size) / 1024)
      if (isNaN(size)) {
        return '-'
      }
      if (size >= 1024) {
        size = Math.floor(parseInt(size) / 1024)
        return size.toString() + 'M'
      } else {
        return size.toString() + 'K'
      }
    },
    getDateString (value) {
      if (typeof value !== 'undefined') {
        var date = new Date(value)
        return date.toISOString().substr(0, 10)
      }
      return '-'
    },
    getLocalDateString (value) {
      if (value) {
        return new Date(value).toISOString().substr(0, 10)
      } else {
        return null
      }
    },
    getOwnerName (item) {
      var name = ''
      for (var index in item.owners) {
        if (item.owners[index].me) {
          name = '自分'
          break
        } else {
          name = item.owners[index].displayName
          break
        }
      }
      return name
    },
    getFolderIcon (item) {
      for (var index in item.permissions) {
        if (item.permissions[index].role !== 'owner') {
          return 'mdi-folder-account'
        }
      }
      return 'mdi-folder'
    },
    gapiUpdateSigninStatus (isSignedIn) {
      var vm = this
      this.isAuthed = isSignedIn
      if (this.isAuthed) {
        if (this.selected === 1) {
          this.loading = true
          this.gapiListFiles(true).then(function () {
            vm.loading = false
          })
        }
      } else {
        if (this.type !== 'open') {
          this.item = null
          this.items = []
          this.tempItems = []
          this.breadcrumbs = []
          this.search = null
          this.searchResult = false
          this.nextPageToken = null
        }
      }
    },
    gapiListFiles (update) {
      return new Promise((resolve) => {
        var vm = this
        var s = "'root' in parents and trashed = false"
        if (this.search !== null && this.search !== '') {
          s = 'fullText contains ' + "'" + this.search + "'" + ' and trashed = false'
        }
        var pageToken = null
        async.doWhilst(function (callback) {
          window.gapi.client.drive.files.list({
            'fields': 'nextPageToken, files(id, name, mimeType, parents, permissions, iconLink, webContentLink, webViewLink, owners, modifiedTime, viewedByMeTime, trashed, createdTime, size, thumbnailLink, shared, description)',
            'pageToken': pageToken,
            'q': s,
            'spaces': 'drive'
          }).then(function (response) {
            var files = response.result.files
            pageToken = response.result.nextPageToken
            for (var index in files) {
              if (files[index].mimeType === 'application/vnd.google-apps.folder') {
                files[index]['children'] = []
              }
              vm.items.push(files[index])
            }
            vm.tempItems = vm.items
            callback()
          }, function (error) {
            if (error) {
              vm.isSignedIn = false
              if (error.status === 401) {
                vm.gisSignIn()
              }
            }
            callback(error)
          })
        }, function () {
          return !!pageToken
        }, function (error) {
          if (error) {
            resolve()
          } else {
            if (!vm.searchResult && update) {
              vm.breadcrumbs.push({
                text: 'Google Drive™',
                disabled: false,
                update: false,
                id: 'root',
                items: vm.items,
                item: vm.items
              })
              if (vm.move && vm.moveFromFolder === null) {
                vm.moveFromFolder = vm.breadcrumbs[vm.breadcrumbs.length - 1]
              }
            }
            resolve()
          }
        })
      })
    },
    gapiListSubFiles (item, update) {
      return new Promise((resolve) => {
        var vm = this
        if (!item.mimeType === 'application/vnd.google-apps.folder') {
          resolve()
          return
        }
        var id = null
        if (typeof item.contents !== 'undefined') {
          id = item.contents.id
        }
        if (typeof item.id !== 'undefined') {
          id = item.id
        }
        var q = "'" + id + "'" + ' in parents and trashed = false'
        window.gapi.client.drive.files.list({
          'fields': 'nextPageToken, files(id, name, mimeType, parents, permissions, iconLink, webContentLink, webViewLink, owners, modifiedTime, viewedByMeTime, trashed, createdTime, size, thumbnailLink, shared, description)',
          'pageToken': vm.nextPageToken,
          'q': q
        }).then(function (response) {
          var files = response.result.files
          vm.nextPageToken = response.result.nextPageToken
          for (var index in files) {
            if (files[index].mimeType === 'application/vnd.google-apps.folder') {
              files[index]['children'] = []
            }
          }
          var newItem = item
          if (typeof item.contents !== 'undefined') {
            newItem['id'] = item.contents.id
          }
          newItem['children'] = files
          if (update) {
            vm.breadcrumbs.push({
              text: newItem.name,
              disabled: false,
              update: false,
              id: newItem.id,
              items: newItem.children,
              item: item
            })
          }
          vm.tempItems = newItem.children
          resolve()
        }, function (error) {
          if (error) {
            vm.isSignedIn = false
            if (error.status === 401) {
              vm.gisSignIn()
            }
          }
          resolve()
        })
      })
    },
    onSignIn (event) {
      this.gisSignIn()
    }
  }
}
</script>

<style scoped>
.v-progress-circular {
  margin: 1rem;
}

.scroller {
  height: 100%;
}

.customHeader {
  cursor: pointer;
  user-select: none;
}

.customLine {
  cursor: pointer;
  user-select: none;
}

.customLine:hover {
  background-color: #CCCCCC20;
}

.select-none {
  user-select: none;
}

.overflow-text-hidden {
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  display: block !important;
  user-select: none !important;
}

.b-B-GREY {
  border-bottom: 1px solid #EEEEEE80 !important;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.b-B-GREY-DARK {
  border-bottom: 1px solid grey !important;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.b-T-GREY-DARK {
  border-top: 1px solid grey !important;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.b-B {
  border-bottom: 1px solid #1976D2 !important;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.rcorners {
  border-radius: 20px;
  border: 1px solid #ECEFF1;
  margin: 2px !important;
  background-color: #F5F5F5;
}
.non-rcorners {
  border-radius: 20px;
  border: 1px solid white;
  margin: 2px !important;
  background-color: white;
}

</style>
